module.exports = __webpack_public_path__ + "img/banner-mobile.6ed4e092.png";